export default "__VITE_ASSET__nHCkfegM__"